module.exports = __webpack_public_path__ + "img/television.32aa1e6a.svg";